module.exports = __webpack_public_path__ + "static/andrey.bb468451.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/andrey.jpg
// module id = 661
// module chunks = 168707334958949